import { useCallback, useState } from 'react';

import type { PUBLISH_ERROR_TYPE } from 'app/components/commons/PublishModalError/PublishModalError';
import { extractMissingFields } from 'app/utils/publishError';

export const usePublishError = () => {
  const [publishErrorType, setPublishErrorType] =
    useState<PUBLISH_ERROR_TYPE | null>(null);
  const [missingFieldsError, setMissingFieldsError] = useState<string[] | null>(
    null
  );

  const openPublishErrorModal = useCallback(
    (error: unknown, type: PUBLISH_ERROR_TYPE) => {
      const missingFields = extractMissingFields(error);

      if (missingFields === null) {
        return;
      }

      setMissingFieldsError(missingFields);
      setPublishErrorType(type);
    },
    []
  );

  const closePublishErrorModal = useCallback(() => {
    setMissingFieldsError(null);
    setPublishErrorType(null);
  }, []);

  return {
    publishErrorType,
    missingFieldsError,
    openPublishErrorModal,
    closePublishErrorModal,
  };
};
